let pendoLoaded = false;

let pendoFunctions = [];

function loadPendo(apiKey) {
  window.pendo_options = {
    apiKey,
    usePendoAgentAPI: true,
  };

  let script = document.createElement('script');

  script.type = 'text/javascript';
  script.async = true;
  script.src = `${
    document.location.protocol === 'https:' ? 'https://' : 'http://'
  }cdn.pendo.io/agent/static/${apiKey}/pendo.js`;
  script.onload = function () {
    pendoLoaded = true;

    if (pendoFunctions.length) {
      pendoFunctions.forEach((pendoFunction) => {
        try {
          pendoFunction();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
      });
    }
    pendoFunctions.length = 0;
  };

  let firstScript = document.getElementsByTagName('script')[0];

  firstScript.parentNode.insertBefore(script, firstScript);
}

function onPendoLoaded(fn) {
  if (pendoLoaded) {
    fn();
  } else {
    pendoFunctions.push(fn);
  }
}

export default {
  loadPendo,
  onPendoLoaded,
};
